import { combineReducers } from 'redux'
import IntroState from './intro'
import LocaleState from './locale'

export default combineReducers({
  IntroState,
  LocaleState
})